import React from 'react';
import GlobalBanner from '../Partials/GlobalBanner/GlobalBanner';
import Section1 from '../Includes/ContactUs/Section1';

const ContactUs = ()=>{

    return (

        <>
            <GlobalBanner title="Contact Us" image="images/contactUs/banner.jpg" />
            <Section1/>
        </>

    );

}

export default ContactUs;